module.exports = __webpack_public_path__ + "static/product-l0980-coyote-tan-41780692acf18e7b9583af4a6c2dfab8.png";